import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`receipts`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`receipts`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`receipts`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`receipts/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`receipts/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`receipts/password`, data);
  return response;
};
